import React, { useState } from "react";
import moment from "moment";
import { Markup } from "interweave";
import { set_active_tab } from "../../Redux/Tab/Tab.action";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import SearchAndFilter from "../SearchAndFilter/SearchAndFilter";
import "./allrfqs.css";
import ListCardLeft from "./ListCardLeft";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import { DownloadIcon, Button } from "evergreen-ui";
import { IMAGE_PATH, PRODUCT } from "../../Utils/variables";
const AllRFQs = () => {
  const { vendorId } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [initialLoading, setinitialLoading] = useState(true);

  const [getFilterData, setgetFilterData] = useState({});
  const navigate = useNavigate();

  const [activeTabId, setActiveTab] = useState(0);
  const [leftCardData, setleftCardData] = useState();
  const [rightCardData, setrightCardData] = useState();
  const [rfqId, setrfqId] = useState();
  const [basicClose, setbasicClose] = useState({
    card1: true,
    card2: true,
    card3: true,
    card4: true,
    card5: true,
    card6: true,
    card7: true,
    card8: true,
  });
  const onClickTabItem = (tabId) => {
    setActiveTab(tabId);
  };

  const openInNewTab = (url) => {
    localStorage.setItem("rfq_id", JSON.stringify(rfqId));
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const searchFucntion = (x) => {
    LeftCardDataLoad(
      getFilterData.Communities,
      getFilterData.manageBy,
      getFilterData.closingOnstart,
      getFilterData.closingOnend,
      getFilterData.postedOnstart,
      getFilterData.postedOnend,
      x
    );
  };

  const LeftCardDataLoad = (
    Communities,
    manageBy,
    closingOnstart,
    closingOnend,
    postedOnstart,
    postedOnend,
    search_query
  ) => {
    fetch(process.env.REACT_APP_API_URL + "/api/vendorRfq/show", {
      method: "POST",
      body: JSON.stringify({
        vendor_id: vendorId,
        communities: Communities,
        manageBy: manageBy,
        closingOnstart: closingOnstart,
        closingOnend: closingOnend,
        postedOnstart: postedOnstart,
        postedOnend: postedOnend,
        search_query: search_query,
      }),
      headers: { "content-type": "application/json" },
    })
      .then((d) => d.json())
      .then((res) => {
        setleftCardData(res.response.data);
        if (res.response.count === 0) {
          setrightCardData();
          setrfqId("");
        } else {
          localStorage.setItem(
            "rfq_id",
            JSON.stringify(res.response.data[0].rfq_id)
          );
          RightCardDataLoad(res.response.data[0].rfq_id);
          setrfqId(res.response.data[0].rfq_id);
        }

        setinitialLoading(false);
      })
      .catch((err) => {
        setinitialLoading(false);
        console.log("e", err);
      });
  };

  const RightCardDataLoad = (x) => {
    if (x) {
      fetch(process.env.REACT_APP_API_URL + "/api/vendorRfq/rfqById", {
        method: "POST",
        body: JSON.stringify({
          rfq_id: x,
          vendor_id: vendorId,
        }),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          setrightCardData(res.response[0]);
        })
        .catch((err) => console.log("e", err));
    }
  };

  const FilterData = (
    Communities,
    manageBy,
    closingOnstart,
    closingOnend,
    postedOnstart,
    postedOnend
  ) => {
    let obj = {
      Communities,
      manageBy,
      closingOnstart,
      closingOnend,
      postedOnstart,
      postedOnend,
    };
    setgetFilterData(obj);
  };

  useEffect(() => {
    RightCardDataLoad(rfqId);
  }, [rfqId]);

  // useEffect(() => {
  //   LeftCardDataLoad();
  // }, []);

  useEffect(() => {
    document.title = PRODUCT + " - RFQ's";
    dispatch(set_active_tab(2));
    LeftCardDataLoad(
      getFilterData.Communities,
      getFilterData.manageBy,
      getFilterData.closingOnstart,
      getFilterData.closingOnend,
      getFilterData.postedOnstart,
      getFilterData.postedOnend
    );
  }, [getFilterData]);
  const handleDownload = (urls) => {
    let url = urls;
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  return (
    <div className="routingSubContainer">
      <Header title={"All RFQs"} />
      <div className="rfqHeadMainTopLevel">
        <SearchAndFilter
          FilterData={FilterData}
          closefilter={true}
          searchFucntion={searchFucntion}
        />
        <div className="rfqHeadMain">
          <div className="rfqLeftDiv">
            <div className="listMainDivHeading">
              <p className="listTopNameLeft">RFQ List</p>
              <p className="listTopNameRight">
                {leftCardData && leftCardData.length} Available
              </p>
            </div>

            <div className="listControlMainDiv">
              {leftCardData && leftCardData.length > 0 ? (
                leftCardData.map((e, i) => {
                  return (
                    <div
                      onClick={() => {
                        onClickTabItem(i);
                        setrfqId(e.rfq_id);
                        localStorage.setItem(
                          "rfq_id",
                          JSON.stringify(e.rfq_id)
                        );
                      }}
                    >
                      <ListCardLeft
                        name={e.name}
                        closing_date={e.closing_date}
                        rfq_title={e.rfq_title}
                        activeTabId={activeTabId}
                        itemId={i}
                      />
                    </div>
                  );
                })
              ) : (
                <div className="noDataToShowList">
                  {initialLoading ? (
                    <i
                      className="fa fa-spinner fa-spin "
                      style={{
                        color: "var(--BaseDarkColor)",
                        fontSize: "40px",
                      }}
                    ></i>
                  ) : (
                    <img src={IMAGE_PATH + "rfqList.svg"} alt="" />
                  )}
                </div>
              )}
            </div>
          </div>

          {/* ---------------------right main data start from here--------------------- */}
          <div className="rfqRightDiv">
            <div className={rightCardData ? "rfqRightDivHead" : ""}>
              <div>
                <div className="rfqRightDivHeadHeading">
                  {rightCardData && rightCardData.rfq_title}
                </div>
                <div className="rfqRightDivHeadSubHeading">
                  {rightCardData && rightCardData.name}
                </div>
              </div>
              <div>
                {rightCardData && (
                  <>
                    <Button
                      className="poppinFont"
                      disabled={
                        rightCardData.status == "Finalised" ? true : false
                      }
                      onClick={() => {
                        navigate("/quotation");
                      }}
                    >
                      {rightCardData.status == "Finalised"
                        ? "Already Applied"
                        : "Apply Now"}
                    </Button>
                  </>
                )}
              </div>
            </div>
            {/* -----------------------right cards-------------------- */}
            {rightCardData ? (
              <div className="rfqRightDivData">
                {/* -----------basic info----------------- */}
                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/basicInfo.svg" alt="" />
                      <span className="rfqsrightdivSubName">General Info</span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card1: !basicClose.card1,
                        });
                      }}
                    >
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        className={!basicClose.card1 && "rotateSvg"}
                        alt=""
                      />
                    </div>
                  </div>
                  {basicClose.card1 && (
                    <div className="basicDetailsDivRfqColumDiv columnImpRfq">
                      <div>
                        <p>RFQ NO</p>
                        <div>{rightCardData && rightCardData.rfq_no}</div>
                        <p>CLOSING ON</p>
                        <div>
                          {rightCardData &&
                            moment(rightCardData.closing_date).format(
                              "DD MMM YYYY"
                            )}
                        </div>
                      </div>

                      <div>
                        <p>POSTED ON</p>
                        <div>
                          {rightCardData &&
                            moment(rightCardData.created_on).format(
                              "DD MMM YYYY"
                            )}
                        </div>
                        <p>Expected Completion/Delivery</p>
                        <div>
                          {rightCardData &&
                            moment(
                              rightCardData.expected_delivery_completion_date
                            ).format("DD MMM YYYY")}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {/* -----------site visit----------------- */}
                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/siteVisit.svg" alt="" />
                      <span className="rfqsrightdivSubName">Site Visit</span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card2: !basicClose.card2,
                        });
                      }}
                    >
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        alt=""
                        className={!basicClose.card2 && "rotateSvg"}
                      />
                    </div>
                  </div>
                  {basicClose.card2 && (
                    <div className="basicDetailsDivRfqColumDiv columnImpRfq">
                      <div>
                        <p>start date</p>
                        <div>
                          {rightCardData &&
                            moment(rightCardData.site_visit_start_date).format(
                              "DD MMM YYYY"
                            )}
                        </div>
                        <p>end date</p>
                        <div>
                          {rightCardData &&
                            moment(rightCardData.site_visit_end_date).format(
                              "DD MMM YYYY"
                            )}
                        </div>
                      </div>
                      <div>
                        <p>start time</p>
                        <div>
                          {rightCardData && rightCardData.site_visit_start_time
                            ? rightCardData.site_visit_start_time
                            : "NA"}
                        </div>
                        <p>end time</p>
                        <div>
                          {rightCardData && rightCardData.site_visit_end_time
                            ? rightCardData.site_visit_end_time
                            : "NA"}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {/* -----------contact info----------------- */}
                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/contactinfo.svg" alt="" />
                      <span className="rfqsrightdivSubName">Contact Info</span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card3: !basicClose.card3,
                        });
                      }}
                    >
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        alt=""
                        className={!basicClose.card3 && "rotateSvg"}
                      />
                    </div>
                  </div>
                  {basicClose.card3 && (
                    <div
                      className="basicDetailsDivRfqColumDiv "
                      id="columnImpRfq"
                    >
                      <div>
                        <p>NAME</p>
                        <div>
                          {rightCardData && rightCardData.contact_person}
                        </div>
                        <p>NUMBER</p>
                        <div>{rightCardData && rightCardData.contact_no}</div>
                      </div>
                      <div>
                        <p>EMAIL</p>
                        <div>{rightCardData && rightCardData.email_id}</div>
                      </div>
                    </div>
                  )}
                </div>
                {/* -----------ITEMS---------------- */}
                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/item.svg" alt="" />
                      <span className="rfqsrightdivSubName">Items</span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card4: !basicClose.card4,
                        });
                      }}
                    >
                      {" "}
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        className={!basicClose.card4 && "rotateSvg"}
                        alt=""
                      />
                    </div>
                  </div>
                  {basicClose.card4 && (
                    <div
                      className="basicDetailsDivRfqColumDiv"
                      id="basicDetailsDivRfqColumDivimp"
                    >
                      <table className="rfqtable">
                        <tr className="rfqtableHead">
                          <th>DESCRIPTION</th>
                          <th>UOM</th>
                          <th>Qty</th>
                        </tr>
                        {rightCardData &&
                          rightCardData.items.map((e) => {
                            return (
                              <tr className="rfqtablData">
                                <td>{e.item}</td>
                                <td>{e.uom_name}</td>
                                <td>{e.quantity}</td>
                              </tr>
                            );
                          })}
                      </table>
                    </div>
                  )}
                </div>

                {/* -----------scope of work---------------- */}

                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/scopeOfWork.svg" alt="" />
                      <span className="rfqsrightdivSubName">Scope of Work</span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card5: !basicClose.card5,
                        });
                      }}
                    >
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        className={!basicClose.card5 && "rotateSvg"}
                        alt=""
                      />
                    </div>
                  </div>
                  {basicClose.card5 && (
                    <div className="basicDetailsDivRfqColumDiv">
                      <div>
                        <div className="rfqMaxWidth">
                          {rightCardData &&
                            rightCardData.scope_of_work
                              .toString()
                              .replace(
                                /<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g,
                                " "
                              )
                              .replace(/[\[\]']+/g, "")}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {/* -----------Terms & Conditions -01---------------- */}

                {
                  rightCardData?.tc && (
                    // rightCardData.tc.map((e, i) => {
                    // return (
                    <div>
                      <div className="basicDetailsDivRfq">
                        <div>
                          <img src="./images/stratum/tandc.svg" alt="" />
                          <span className="rfqsrightdivSubName">
                            Terms & Conditions
                          </span>
                        </div>
                        <div
                          className="basicDetailsDivRfqLogoDrop"
                          onClick={() => {
                            setbasicClose({
                              ...basicClose,
                              card6: !basicClose.card6,
                            });
                          }}
                        >
                          <img
                            src="./images/stratum/dropUpLogo.svg"
                            className={!basicClose.card6 && "rotateSvg"}
                            alt=""
                          />
                        </div>
                      </div>
                      {basicClose.card6 && (
                        <div className="basicDetailsDivRfqColumDiv">
                          <div>
                            <div className="rfqMaxWidth">
                              {rightCardData.tc.map((e, i) => {
                                return (
                                  <>
                                    <Markup
                                      className="marginTandCinRrqtitle"
                                      content={e.title}
                                    />

                                    <Markup
                                      className="marginTandCinRrqdesc"
                                      content={e.desc}
                                    />
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )
                  // );
                  // })
                }
                {/* -----------Terms & Conditions -02--------------- */}

                {/* <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/tandc.svg" alt="" />
                      <span className="rfqsrightdivSubName">
                        Terms & Conditions -02
                      </span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card7: !basicClose.card7,
                        });
                      }}
                    >
                      <img src="./images/stratum/dropUpLogo.svg" alt="" />
                    </div>
                  </div>
                  {basicClose.card7 && (
                    <div className="basicDetailsDivRfqColumDiv">
                      <div>
                        <div className="rfqMaxWidth">
                          {rightCardData && rightCardData.terms_condition}
                        </div>
                      </div>
                    </div>
                  )}
                </div> */}
                {/* -----------Attachments----------------- */}
                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/attachment.svg" alt="" />
                      <span className="rfqsrightdivSubName">Attachments</span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card8: !basicClose.card8,
                        });
                      }}
                    >
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        className={!basicClose.card8 && "rotateSvg"}
                        alt=""
                      />
                    </div>
                  </div>
                  {basicClose.card8 && (
                    <div className="basicDetailsDivRfqColumDiv columnImpRfq">
                      <div>
                        {/* <p></p>
                        <div>img1</div>
                        <p></p>
                        <p></p>
                        <div>img2</div> */}
                        {rightCardData &&
                          rightCardData.documents.map((item) => {
                            return (
                              <>
                                <p></p>
                                <div className="imageLabelId">
                                  {item.orig_name.slice(0, 20)}...
                                </div>
                              </>
                            );
                          })}
                      </div>
                      <div>
                        {/* <p></p>
                        <Button
                         marginY={8} 
                         marginRight={12} 
                         iconBefore={DownloadIcon}
                         onClick={handleDownload}
                         >
                          Download
                        </Button>
                        <p></p>
                        <div>
                          <img
                            src="./images/stratum/download.svg"
                            alt=""
                            className="dimg"
                          />
                          download2
                        </div> */}
                        {rightCardData &&
                          rightCardData.documents.map((item) => {
                            return (
                              <>
                                <p></p>
                                <Button
                                  className="downloadBtn"
                                  // marginY={8}
                                  // marginRight={12}
                                  height={32}
                                  width={110}
                                  iconBefore={DownloadIcon}
                                  onClick={() => handleDownload(item?.urls)}
                                >
                                  Download
                                </Button>
                              </>
                            );
                          })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="noDataToShow">
                <img src={IMAGE_PATH + "rfqDetails.svg"} alt="abc" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllRFQs;
